import { render, staticRenderFns } from "./ReachAnnex17Properties.vue?vue&type=template&id=368a38d0&"
import script from "./ReachAnnex17Properties.vue?vue&type=script&lang=js&"
export * from "./ReachAnnex17Properties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports